export default __webpack_public_path__ + "static/bradford-6eb9456f16cd4024cebb576d4b3b0f77.jpg";